var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import * as React from "react";

function SvgUtsLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 980,
    height: 420,
    viewBox: "0 0 980 420",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 490 210)",
    id: "8b753387-d031-4057-8c8e-1c192046bfba"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -490,
    y: -210,
    rx: 0,
    ry: 0,
    width: 980,
    height: 420
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(Infinity NaN NaN Infinity 0 0)",
    id: "1448d1a5-5067-4560-a017-c5ecefcd4496"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.47 0 0 0.47 490 210)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.8 0 0 4.8 353.18 49.48)"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    points: "-39.31,-37.45 -13.29,-37.45 -13.29,61.05 13.28,61.05 13.28,-37.45 39.31,-37.45 39.31,-61.05 -39.31,-61.05 -39.31,-37.45 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.8 0 0 4.8 -146.56 53.92)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-270.56, -191.05)",
    d: "M 285.42 213.44 C 285.42 223.29 279.66 229.44 270.55 229.44 C 261.26 229.44 255.68 223.31 255.68 213.44 L 255.68 129.07 L 229.11 129.07 L 229.11 213.81 C 229.11 237.97 245.83 253.02 270.55 253.02 C 295.27 253.02 312 238 312 213.81 L 312 129.07 L 285.42 129.07 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.8 0 0 4.8 817.27 49.53)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-471.5, -190.13)",
    d: "M 482.84 178.69 L 467.59999999999997 172.93 C 459.23999999999995 169.77 457.74999999999994 164.38 457.74999999999994 160.85 C 457.74999999999994 154.16 462.5799999999999 149.14 471.12999999999994 149.14 C 479.49999999999994 149.14 485.06999999999994 154.72 485.06999999999994 163.45 L 485.06999999999994 166.79999999999998 L 510 166.79999999999998 L 510 164 C 510 141.32999999999998 494.39 127.2 471.15999999999997 127.2 C 446.82 127.2 432.7 143.93 432.7 162.51 C 432.7 180.35 441.99 190.95 459.64 197.64 L 476.74 204.14 C 484.36 207.14 487.33 211.2 487.33 217.32999999999998 C 487.33 225.88 481.76 230.89999999999998 471.71999999999997 230.89999999999998 C 461.67999999999995 230.89999999999998 455.54999999999995 226.24999999999997 455.54999999999995 216.40999999999997 L 455.54999999999995 212 L 430.44 212 L 430.44 216.27 C 430.44 238.94 447.9 253.06 471.69 253.06 C 497.69 253.06 512.57 237.27 512.57 214.78 C 512.57 192.29 498.08 184.45 482.84 178.69 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.39 -3.39 3.39 3.39 -958.65 -1.98)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x: -8.165,
    y: -8.165,
    rx: 0,
    ry: 0,
    width: 16.33,
    height: 16.33
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.8 0 0 4.8 -847.81 57.58)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-124.35, -191.81)",
    d: "M 138.64 182.15 L 147.42999999999998 190.94 L 159 179.39 L 147.23 167.63 C 144.9566646402742 165.35408100422669 141.8718091228889 164.07526561176007 138.65499999999997 164.07526561176007 C 135.43819087711108 164.07526561176007 132.35333535972578 165.35408100422669 130.07999999999998 167.63 L 89.7 208 L 101.24000000000001 219.54 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.8 0 0 4.8 -890.02 255.02)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-115.55, -232.97)",
    d: "M 135.89 231.09 L 124.33999999999999 219.54 L 115.54999999999998 228.32999999999998 L 106.74999999999999 219.54 L 95.21 231.09 L 107 242.85 C 109.27333535972579 245.1259189957733 112.3581908771111 246.40473438823992 115.575 246.40473438823992 C 118.7918091228889 246.40473438823992 121.87666464027421 245.1259189957733 124.15 242.85 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.8 0 0 4.8 -779.23 365.89)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-138.65, -256.09)",
    d: "M 138.64 251.42 L 129.83999999999997 242.63 L 118.3 254.18 L 130.06 266 C 134.7988349970973 270.72860982151764 142.47116500290272 270.72860982151764 147.21 266 L 159 254.18 L 147.45 242.63 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.8 0 0 4.8 -668.53 255.02)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-161.73, -232.97)",
    d: "M 161.73 228.33 L 152.94 219.54000000000002 L 141.39 231.09000000000003 L 153.16 242.85000000000002 C 155.4333353597258 245.12591899577333 158.5181908771111 246.40473438823994 161.735 246.40473438823994 C 164.9518091228889 246.40473438823994 168.0366646402742 245.12591899577333 170.31 242.85000000000002 L 182.07 231.09000000000003 L 170.51999999999998 219.54000000000002 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.39 -3.39 3.39 3.39 -599.94 135.19)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x: -8.165,
    y: -8.165,
    rx: 0,
    ry: 0,
    width: 16.33,
    height: 16.33
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.8 0 0 4.8 -710.69 75.66)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-152.94, -195.58)",
    d: "M 138.64 205.24 L 129.83999999999997 196.45000000000002 L 118.3 208 L 130.06 219.76 C 132.3333353597258 222.0359189957733 135.4181908771111 223.3147343882399 138.635 223.3147343882399 C 141.8518091228889 223.3147343882399 144.93666464027422 222.0359189957733 147.21 219.76 L 187.58 179.39 L 176 167.84 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.39 -3.39 3.39 3.39 -779.25 -356.37)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x: -10.89,
    y: -10.89,
    rx: 0,
    ry: 0,
    width: 21.78,
    height: 21.78
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.8 0 0 4.8 -779.49 -192.3)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-138.59, -139.71)",
    d: "M 119.43 140.56 L 130.43 140.56 L 130.43 162.42000000000002 C 135.46830672475258 159.45035703198207 141.72169327524742 159.45035703198207 146.76 162.42000000000002 L 146.76 140.56 L 157.76 140.56 L 164.98999999999998 147.8 L 180.39 132.4 L 165.08 117 L 157.85000000000002 124.24 L 119.43 124.24 L 112.19 117 L 96.8 132.4 L 112.19 147.8 Z",
    strokeLinecap: "round"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtsLogoWhite);
export default __webpack_public_path__ + "static/media/UTS_logo_white.a336266f325449e871348fae360f363a.svg";
export { ForwardRef as ReactComponent };